import { render, staticRenderFns } from "./cis_business2024.vue?vue&type=template&id=157412de&scoped=true"
import script from "./cis_business2024.vue?vue&type=script&lang=js"
export * from "./cis_business2024.vue?vue&type=script&lang=js"
import style0 from "./cis_business2024.vue?vue&type=style&index=0&id=157412de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157412de",
  null
  
)

export default component.exports